export default {
  searchTitle: 'Search Results',
  searchPlaceholder: 'Search articles...',
  searchButton: 'Search',
  searchLoading: 'Searching...',
  // 含 query 的副标题前缀：组件内拼接 query（如 "Results for tone"）
  searchResultsForPrefix: 'Results for ',
  searchEmptyTitle: 'No Results',
  // 含 query 的空结果说明：组件内拼接 prefix + query + suffix，
  // 避免运行时依赖字符串插值能力（query 可能含特殊字符）
  searchEmptyQueryPrefix: 'No results found for "',
  searchEmptyQuerySuffix: '"',
  searchResultCount: '{count} results',
};
